import BootstrapVue from 'bootstrap-vue'
import Vue from 'vue'

import FormulatePlugin from '@/plugins/FormulatePlugin'
import McToastAlertPlugin from '@/plugins/McToastAlertPlugin'
import ErrorDescriptionPlugin from '@/plugins/error-description-plugin'
import vco from 'v-click-outside'
import VueCookies from 'vue-cookies'
import VueObserveVisibility from 'vue-observe-visibility'
import VueRouter from 'vue-router'
import VueSweetalert2 from 'vue-sweetalert2'
import * as VueGoogleMaps from 'vue2-google-maps'
import Vuelidate from 'vuelidate'
import router from './router/index'

import '../src/design/app.scss'

import store from '@/state/store'

import App from './App.vue'

import i18n from './i18n'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/id'

import GmapCluster from 'vue2-google-maps/src/components/cluster'
import { LMap, LTileLayer, LMarker, LCircle } from 'vue2-leaflet';
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';

import VuejsDialog from 'vuejs-dialog'
// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

import Toast from 'vue-toastification'
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css'

import { client } from '@/services/apolloclient'
import VueApollo from 'vue-apollo'

import axios from 'axios'

import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';

Vue.component('v-marker-cluster', Vue2LeafletMarkerCluster);

Vue.use(Toast)
export const eventBus = new Vue();
Vue.use(McToastAlertPlugin)
Vue.use(ErrorDescriptionPlugin)
Vue.use(VueCookies)
Vue.use(VueRouter)
const VueScrollTo = require('vue-scrollto')
Vue.use(vco)
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2)
Vue.use(FormulatePlugin)
Vue.use(VueObserveVisibility)

Vue.component('v-select', vSelect)
Vue.use(DatePicker)
Vue.component('GmapCluster', GmapCluster)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
    libraries: 'places,geometry,drawing',
    place: 'geometry,drawing',
    autobindAllEvents: false,
  },
  installComponents: true,
})

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-circle', LCircle);
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Tell Vue to install the plugin.
Vue.use(VuejsDialog, {
  html: false,
  loader: true,
  okText: 'Ya',
  cancelText: 'Tidak',
  animation: 'bounce',
  backdropClose: true,
})
Vue.use(VueApollo)
const apolloProvider = new VueApollo({
  defaultClient: client,
})

window.axios = axios
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_APIGO_URL || ''
axios.interceptors.request.use((config) => {
  config.headers.common = {
    Authorization: `Bearer ${localStorage.getItem('tokenAccess')}`,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }

  return config
})

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const data = error.response.data
    if (data.status === 401) {
      // localStorage.removeItem('token')
      // localStorage.removeItem('tokenAccess')
      // router.push({ name: 'Login' })
    }
    return Promise.reject(error)
  }
)

import './registerServiceWorker'

import { initRemoteConfig } from './services/flags'
;(async () => {
  await initRemoteConfig()
})()

store
  .dispatch('identity/init')
  .then((data) => {
    localStorage.setItem(
      'wsToken', data?.wsToken
    )
    store.dispatch('identity/getFeatureFlag')
    const vue = new Vue({
      router,
      store,
      i18n,
      apolloProvider,
      render: (h) => h(App),
    })
    vue.$mount('#app')
  })
  .catch((e) => {
    /**
     * TODO: Show error page
     */
    console.log(e)
  })
